import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useReduxState } from "src/hooks/useRedux";
import { useStaticSelect } from "src/hooks/form/useSelect";
import masterDataProto from "src/Library/MasterDataType";

const useIncoterm = <T>({
  props,
  defaultMode,
  showAll = false,
} : {
  props: useFieldProps<T>,
  defaultMode: "AIRCARGO" | "LCL" | "FCL",
  showAll?: boolean,
}) => {
  const field = useStaticSelect<string[], T>(props);

  const [mode, setMode] = React.useState(defaultMode);
  const incoterms: typeof masterDataProto.execution.shippingModeToValidIncotermMapping = useReduxState(
    ["masterData", "execution", "shippingModeToValidIncotermMapping"]
  ).value;

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  }

  React.useEffect(() => {
    setMode(defaultMode);
  }, [defaultMode]);

  React.useEffect(() => {
    field.setValue("");
    field.setOptionsData(incoterms[mode], (data) => {
      return data?.map((el) => ({ key: el, label: el })) || [];
    });
  }, [incoterms, mode]);

  return {
    ...field,
    setMode,
  };
};

export default useIncoterm;
